import type { BlokProps } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokUspItem } from "@/storyblok";
import styles from "./UspItemBlok.module.css";

export const UspItemBlok = ({ blok }: BlokProps<BlokUspItem>) => {
	return (
		<BlokWrap editable={blok} className={styles.root}>
			<div className={styles.content}>
				<span className={styles.title}>{blok.title}</span>
				<p className={styles.description}>{blok.description}</p>
			</div>
		</BlokWrap>
	);
};
